import { render, staticRenderFns } from "./cast.vue?vue&type=template&id=dec2c4c2&scoped=true"
import script from "./cast.vue?vue&type=script&lang=js"
export * from "./cast.vue?vue&type=script&lang=js"
import style0 from "./cast.vue?vue&type=style&index=0&id=dec2c4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec2c4c2",
  null
  
)

export default component.exports